import { render } from "./Aula.vue?vue&type=template&id=aeeefa2a"
import script from "./Aula.vue?vue&type=script&lang=ts"
export * from "./Aula.vue?vue&type=script&lang=ts"
script.render = render

export default script